import * as Yup from "yup";

export const validationSchema = Yup.object().shape({
  currentPassword: Yup.string().required("Current password is required"),
  newPassword: Yup.string()
    .required("New password is required")
    .min(8, "Password must be at least 8 characters long")
    .max(30, "Password must not exceed 30 characters")
    .matches(
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*(),.?":{}|<>[\]\\';'`~\-_=+])[A-Za-z\d!@#$%^&*(),.?":{}|<>[\]\\';'`~\-_=+]{8,30}$/,
      "Password must contain uppercase, lowercase, number, and special character"
    ),
  confirmNewPassword: Yup.string()
    .oneOf([Yup.ref("newPassword")], "Passwords must match")
    .required("Confirm new password is required"),
});

export const loginValidationSchema = Yup.object().shape({
  userId: Yup.string().required("Username is required."),
  password: Yup.string()
    .required("Password is required.")
    // .min(8, "Password must be at least 8 characters long.")
    .max(30, "Password must not exceed 30 characters"),
});
